const globalStates = (state = { is_loading: false, quotes: [], selected_quotes: [], reshuffle: 0 }, action) => {
  return returnAction(action, state);
}

function returnAction(action, state) {
  let type = action.type.toLowerCase().replace('update_', '');
  if(action.type === 'RESET_STATES') {
    const statesToClear = [
      'pa_options',
      'car_brands',
      'is_loading',
      'banks',
      'aon_options',
      'vehicle_types'
    ]
    Object.keys(state).forEach((x, i) => {
      if(statesToClear.indexOf(x) === -1) {
        state[x] = null;
      }
    })
    return { ...state }
  } else {
    state[type] = action.payload
    return {
      ...state
    }
  }
}

export default globalStates;